import service from './request'
import md5 from 'js-md5';
import util from '@/util/util.js'
//新闻列表
export const news = data => {
    if (typeof (data) == 'string') {
        return service({
            url: `/news/more?channelName=${data}`,
            method: 'get',
        })
    } else {
        return service({
            url: `/news/more?channelName=${data.channelName}&pageNum=${data.pageNum}&pageSize=10`,
            method: 'get',
        })
    }
}
// 新闻目标 
export const newsTarget = data => {
    return service({
        url: `/sdg/target/list`,
        method: 'get',
    })
}
// 搜索新闻 
export const searchNews = data => {
    var srtUrl =  `/news/search?channelName=${data.channelName}&pageSize=${data.pageSize}&pageNum=${data.pageNum}`
    if(data.mouth){
        srtUrl += `&mouth=${data.mouth}`
    }
    if(data.sdgId){
        srtUrl += `&sdgId=${data.sdgId}`
    }
    console.log(srtUrl)
    return service({
        url: srtUrl,
        method: 'get',
    })
}

export const newsDetails = data => {
    return service({
        url: `/news/${data}`,
        method: 'get',
    })
}


export const relatedNews = data => {
    return service({
        url: `/news/${data}/relatedNews`,
        method: 'get',
    })
}

export const otherNews = data => {
    return service({
        url: `/news/${data}/otherNews`,
        method: 'get',
    })
}
